import { graphql, PageProps } from 'gatsby';
import React from 'react';

import Layout from '../components/layouts/Layout';
import PromoScreen from '../components/screens/PromoScreen/PromoScreen';
import { StoreLocatorProvider } from '../components/StoreLocator';
import { CMSPageData, ContentfulPage } from '../ContentfulTypes';
import { GatsbyPageContextProps } from '../types';
import variables from '../styles/variables';

const PromoPage = ({
  pageContext,
  location,
  data,
}: PageProps<CMSPageData, GatsbyPageContextProps>) => (
  <StoreLocatorProvider>
    <Layout
      locale={pageContext.locale}
      location={location}
      backgroundColor={variables.colorGrey2}
    >
      <PromoScreen
        locale={pageContext.locale}
        contentfulData={data.contentfulPage as ContentfulPage}
      />
    </Layout>
  </StoreLocatorProvider>
);

// ts-prune-ignore-next
export const query = graphql`
  query promoPageData($formattedLocale: String = "en-CA") {
    contentfulPage(
      contentful_id: { eq: "7pbM8ipfvM71U5nlkXVmjQ" }
      node_locale: { eq: $formattedLocale }
    ) {
      metaTitle
      metaDescription {
        metaDescription
      }
      contentful_id
      node_locale
      pageSlug
      pageSections {
        ...MultiHeroBannerQuery
        ... on ContentfulBlade {
          __typename
          contentful_id
          bladeCloseLabel
          bladeSections {
            ... on ContentfulTextSection {
              __typename
              heading {
                raw
              }
              contentful_id
              subHeading {
                raw
              }
              heading {
                raw
              }
            }
            ... on ContentfulForm {
              __typename
              id
              formFields {
                displayLabel
                placeholderLabel
                errorMessage
                fieldName
                __typename
                contentful_id
              }
            }
            ... on ContentfulCta {
              __typename
              id
              ctaColor
              ctaTarget
              ctaType
              ctaUrl
              ctaLabel {
                ctaLabel
              }
              ctaAriaLabel
            }
          }
        }
        ... on ContentfulCombinatorSection {
          __typename
          contentful_id
          combinatorSectionItems {
            ... on ContentfulTextSection {
              __typename
              id
              heading {
                raw
              }
            }
            ... on ContentfulForm {
              __typename
              id
              contentful_id
              formFields {
                displayLabel
                contentful_id
                placeholderLabel
              }
            }
            ... on ContentfulImageSection {
              __typename
              id
              backgroundImageDesktop {
                altText
                asset {
                  url
                  localImage {
                    id
                    publicURL
                    childImageSharp {
                      gatsbyImageData
                    }
                  }
                }
              }
              backgroundImageMobile {
                altText
                asset {
                  url
                  localImage {
                    id
                    publicURL
                    childImageSharp {
                      gatsbyImageData
                    }
                  }
                }
              }
              backgroundImageTablet {
                altText
                asset {
                  url
                  localImage {
                    id
                    publicURL
                    childImageSharp {
                      gatsbyImageData
                    }
                  }
                }
              }
            }
            ... on ContentfulStoreLogosSection {
              __typename
              id
              tmsStores {
                storeName
                storeId
                logo {
                  altText
                  asset {
                    url
                    localImage {
                      id
                      publicURL
                      childImageSharp {
                        gatsbyImageData
                      }
                    }
                  }
                }
                storeRegion
              }
            }
          }
        }
        ... on ContentfulTextSection {
          __typename
          contentful_id
          heading {
            raw
          }
          subHeading {
            raw
          }
          contentBody {
            raw
            references {
              ... on ContentfulCta {
                id
                contentful_id
                ctaColor
                ctaTarget
                ctaType
                ctaUrl
                ctaLabel {
                  ctaLabel
                }
              }
              ... on ContentfulDamAsset {
                contentful_id
                asset {
                  id
                  url
                  mimeType
                  localImage {
                    id
                    publicURL
                    childImageSharp {
                      gatsbyImageData
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default PromoPage;
